import { CLIENT_ROUTE_ID } from './common';
import ClientManagement from './components/ClientManagement';

export default {
    [CLIENT_ROUTE_ID]: () => <ClientManagement />
};
